import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderProps } from 'react-oidc-context';
import { getSubdomain } from 'utils/url';

const keycloakUrl = (process.env.REACT_APP_KEYCLOAK_SERVER_URL || '').replace(/\/+$/, '');
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM || '';
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '';

export const oidcRuntime = {
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  clientId: keycloakClientId,
  redirectUri: `${window.location.origin}/login`,
};

const subdomain = getSubdomain();

const oidcConfig: AuthProviderProps = {
  authority: oidcRuntime.authority,
  client_id: oidcRuntime.clientId,
  redirect_uri: oidcRuntime.redirectUri,
  post_logout_redirect_uri: `${window.location.origin}/login`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Add subdomain as extra query param if available
  extraQueryParams: subdomain ? { subdomain } : undefined,
  onSigninCallback: () => {
    // Navigate to login page after callback, which will then handle user info
    window.history.replaceState({}, document.title, '/login');
  },
} as AuthProviderProps;

export default oidcConfig;
